














































import DocumentLink from '@/components/DocumentLink'
import FooterContactBlock from '@/components/FooterContactBlock'
import FooterSocialMediaList from '@/components/FooterSocialMediaList'

export default {
    name: 'PageFooter'

    components:
        DocumentLink: DocumentLink
        FooterContactBlock: FooterContactBlock
        FooterSocialMediaList: FooterSocialMediaList

    props: ['id']

    data: ->
        documentId: '' 
        fields: @defaultFields()

    methods:
        defaultFields: ->  
            logo: []
            copyright: []
            contact_block: []
            imprint: []
            privacy: []
            agbs: []
            social_media_list: []

        setContent: (document) ->
            @documentId = document.id
            fields = 
                logo: document.data.logo
                copyright: document.data.copyright
                contact_block: document.data.contact_block
                imprint: document.data.imprint
                privacy: document.data.privacy
                agbs: document.data.agbs
                social_media_list: document.data.social_media_list
            $.extend @fields, fields

        getContent: (id) ->
            @$prismic.client.query(@$prismic.Predicates.at 'document.id', id).then (response) =>
                if response.results then @setContent response.results[0]
        
    created: ->
        @getContent @id
}
